import { sl, type Translations } from "./translations/sl";
import { en } from "./translations/en";

export type Language = "sl" | "en";

export { sl, type Translations } from "./translations/sl";
export { en } from "./translations/en";

const translations: Record<string, Translations> = { sl, en };

/** Server-side helper to get translations for a language */
export function getTranslations(lang: string): Translations {
  return translations[lang] || translations.sl;
}
